export enum QuestionType {
  CompanyForm = 'company_form',
  CompanySize = 'company_size',
  SignupFeatures = 'signup_features',
}
